import $ from 'jquery';

/**
 * The XPath selector for the forms
 *
 * @var string
 */
const selector = 'form.timed-exercise';

/**
 * Interval in miliseconds for the timer function
 *
 * @var int
 */
const timerInterval = 1000;

/**
 * The average number of words a user can read per minute
 *
 * @var int
 */
const wordsPerMinute = 250;

/**
 * Ignore the elapsed time if the elapsed time is smaller than this number
 *
 * @var int
 */
const ignoreTimeSmallerThan = 10;

/**
 * Check if an element is inside the viewport
 *
 * @param   HTMLElement  elem   Any element in the page
 *
 * @return  bool                Returns true if the element is inside the viewport or false otherwise
 */
function isInViewport(element) {
    let bounds = $(element).get(0).getBoundingClientRect(),
        viewport = {
            height: (window.innerHeight || document.documentElement.clientHeight),
            width: (window.innerWidth || document.documentElement.clientWidth)
        };

    return (
        bounds.top < viewport.height && bounds.bottom > 0 &&
        bounds.left < viewport.width && bounds.right > 0
    );
};

/**
 * Clear a timer on a form
 *
 * @param   HTMLElement  $form  The form
 *
 * @return  void
 */
function clearTimer($form) {
    let interval = $form.data('timed-exercise-timer'),
        intervalWasRunning = !!interval;

    // Clear the interval so it doesn't increase the time anymore
    clearInterval(interval);
    $form.data('timed-exercise-timer', null);

    if (intervalWasRunning) {
        // Ignore if the elapsed time is smaller than ignoreTimeSmallerThan
        let elapsedTime = parseInt($form.data('timed-exercise-current-interval') || 0, 10);
        if (elapsedTime >= ignoreTimeSmallerThan) {
            // Set the new value of the timer
            let $timer = $form.find('input[name=timer]');
            $timer.val(parseInt(($timer.val() || 0), 10) + elapsedTime);
            if (navigator && navigator.sendBeacon) {
                // Use navigator.sendBeacon() to make the browser send the data when the user closes the page or navigates away
                navigator.sendBeacon($form.attr('action'), new FormData($form.get(0)));
            } else {
                // Fallback to ajax if navigator.sendBeacon() is not available
                $.ajax({
                    type: 'POST',
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    headers: {
                        'Ajax-Request': 'yes'
                    }
                });
            }
        } else {
            $form.data('timed-exercise-current-interval', 0);
        }
    }
}

/**
 * Process elements in the viewport
 *
 * @param   Event  event  The Event object
 *
 * @return  void
 */
function processElementsInViewport(event) {
    // Loop through all forms
    $(selector).each(function (i, form) {
        let $form = $(form),
            $element = $($form.attr('data-target'));

        // Check if the target element is in the viewport
        if (isInViewport($element)) {
            // Calculate the expected time if it was not given by the controller
            if (!$form.attr('data-expected-time')) {
                let expectedTime = Math.round($element.text().trim().split(' ').length / wordsPerMinute * 60);
                $form.attr('data-expected-time', expectedTime);
                $form.find('input[name=expected_time]').val(expectedTime);
            }

            // Check if there is already an interval running, and if not create an interval function
            let interval = $form.data('timed-exercise-timer');
            if (!interval) {
                // Set current amount of seconds elapsed in the interval to 0
                $form.data('timed-exercise-current-interval', 0);
                interval = setInterval(function () {
                    // Increase the amount of time elapsed of the timer
                    $form.data('timed-exercise-current-interval', parseInt($form.data('timed-exercise-current-interval') || 0, 10) + (timerInterval/1000));
                }, timerInterval);
                $form.data('timed-exercise-timer', interval);
            }
        } else {
            // Clear the timer and submit the elapsed time
            clearTimer($form);
        }
    });
}

// Add event listeners to process the elements that are inside the viewport
window.addEventListener('scroll', processElementsInViewport, false);
window.addEventListener('load', processElementsInViewport, false);
window.addEventListener('resize', processElementsInViewport, false);

// Add event listener to detect if the tab is opened in the browser or not.
// The visibilitychange event allows us to use navigator.sendBeacon() to send the data to the server when the user
// navigates away from the page as well and is more reliable than using the onbeforeunload or onunload event.
window.addEventListener('visibilitychange', function (event) {
    if (document.hidden) {
        // Clear the timers when the user switched to another browser tab and submit the elapsed time.
        $(selector).each(function (i, form) {
            clearTimer($(form));
        });
    } else {
        // Restart the timers when the user switched back to this browser tab
        processElementsInViewport(event);
    }
}, false);

export default {};